<template>
	<div class="container-summary">
		<div class="column-summary with-border">
			<div class="summary-header">
				<p>{{ startPriceNameFallback }}</p>
			</div>
			<div class="summary-body">
				<p>{{ currencyStore.readableCurrencyValue(start, true, false) }}</p>
			</div>
		</div>
		<div class="column-summary with-border">
			<div class="summary-header">
				<p>{{ discountWord }}</p>
			</div>
			<div class="summary-body">
				<p>{{ (discountNumber > 0 ? '+' : '')+currencyStore.readableCurrencyValue(discountNumber, true, false) }}</p>
			</div>
		</div>
		<div class="column-summary">
			<div class="summary-header">
				<p>{{ getString('total') }}</p>
			</div>
			<div class="summary-body main-value">
				<p>{{ currencyStore.readableCurrencyValue(end, true, false) }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, currencyStore};
	},
	name: "BottomNumberEditorSummary",
	props: {
		start: {
			type: Number,
			required: true,
		},
		end: {
			type: Number,
			required: true,
		},
		startPriceName: {
			type: String,
			default: null,
		},
	},
	computed: {
		discountNumber() {
			return this.end - this.start;
		},
		discountWord() {
			if(this.discountNumber > 0) {
				return this.getString("increase");
			} else {
				return this.getString("difference");
			}
		},
		startPriceNameFallback() {
			return this.startPriceName || this.getString("price");
		},
	},
}
</script>

<style scoped lang="scss">
.container-summary {
	width: 100%;
	display: flex;
	flex-direction: row;
	background-color: var(--color-bg);
	border-radius: 13px;
	box-shadow: inset 0 1px 2px var(--color-alpha-4);

	.column-summary {
		width: calc(100% / 3);
		display: flex;
		flex-direction: column;

		.summary-header {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 30px;
			border-bottom: 1px solid var(--color-alpha-4);

			p {
				font-size: 14px;
				font-weight: 700;
				color: var(--color-txt);
				@include truncateString();
			}

			@media (max-width: 400px) {
				p {
					font-size: 12px;
				}
			}
		}

		.summary-body {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 60px;

			p {
				font-size: 18px;
				font-weight: 700;
				color: var(--color-txt);
				@include truncateString();
			}

			&.main-value p {
				color: $primary;
				font-size: 22px;
			}

			@media (max-width: 400px) {
				min-height: 40px;

				p {
					font-size: 15px;
				}

				&.main-value p {
					font-size: 18px;
				}
			}
		}

		&.with-border {
			border-right: 1px solid var(--color-alpha-4);
		}
	}
}
</style>